import React, { useState, useMemo } from "react"

import { useAccount } from "../../../hooks/useAccount"
import { useApp } from "../../../hooks/useApp"
import { useTemplate } from "../../../hooks/useTemplate"

export const withArticleNavigation = Component => ({ name = "ArticleNavigation", category, navigation }) => {
  const { activeSubscription, profile } = useAccount()
  const { setRegister } = useApp()
  const [active, setActive] = useState(false)
  const [open, setOpen] = useState(category?.title)
  const { global: locales } = useTemplate()

  const handleActive = () => setActive((prevState: boolean) => !prevState)
  const handleOpen = (category: string) => setOpen(category)
  const handleRegister = () => setRegister((prevState: boolean) => !prevState)

  const accountType = useMemo(() => [activeSubscription ? "subscribed" : "", profile ? "members" : "", "public"]?.filter(Boolean), [
    profile,
    activeSubscription,
  ])

  Component.displayName = name
  return (
    <Component
      active={active}
      handleActive={handleActive}
      handleOpen={handleOpen}
      locales={locales}
      navigation={navigation}
      open={open}
      accountType={accountType}
      handleRegister={handleRegister}
    />
  )
}
